import React,{useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faUsers, faClock, faPlay, 
  faCheckCircle, faChartBar, faChartLine,
  faDatabase, faProjectDiagram, faLaptopCode, 
  faCertificate, faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import './HeroSection.css';

const Tableau = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('Tableau');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <span className="badge bg-primary bg-opacity-10 text-white mb-3">New Tableau Certification</span>
              <h1 className="hero-title">
                Master <span className="hero-highlight">Tableau</span>
              </h1>
              <p className="hero-subtitle">
                Become a Tableau expert with our comprehensive certification program. 
                Gain hands-on experience with data visualization, dashboard design, 
                and advanced analytics to transform raw data into powerful insights.
              </p>
              
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.9/5.0</div>
                    <small className="text-muted">(3,700 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">15,000+</div>
                    <small className="text-muted">Certified Professionals</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">60 hours</div>
                    <small className="text-muted">Hands-on Practice</small>
                  </div>
                </div>
              </div>
              
             <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img 
                  src="subcourses-images/tabula.jpg" 
                  alt="Tableau Certification Course" 
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="course-details">
          <div className="course-content">
            {/* About Course */}
            <section className="about-course">
              <h2 className="section-title">About This Certification</h2>
              <p>This comprehensive Tableau certification program prepares you for data analyst and visualization specialist roles. You'll gain expertise in data storytelling, dashboard creation, and advanced analytics techniques used by leading organizations.</p>
              <p>Through real-world datasets and practical exercises, you'll build the skills needed to pass Tableau certifications and create impactful data visualizations.</p>
            </section>
            
            {/* Curriculum */}
            <section className="curriculum">
              <h2 className="section-title">Certification Path</h2>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faChartBar} className="me-2" /> Module 1: Tableau Fundamentals</h3>
                <p>Master core Tableau concepts and interface</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data connection & preparation</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Basic visualizations</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Calculations & aggregations</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Dashboard basics</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faChartLine} className="me-2" /> Module 2: Intermediate Tableau</h3>
                <p>Develop advanced visualization techniques</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Parameters & sets</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Advanced calculations</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Table calculations</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Mapping techniques</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 3: Data Preparation</h3>
                <p>Master data transformation in Tableau</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data blending</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Prep Builder</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data modeling</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Performance optimization</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 4: Advanced Dashboarding</h3>
                <p>Create professional, interactive dashboards</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Dashboard design principles</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Actions & interactivity</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Story points</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Best practices</div>
                </div>
              </div>
              
              <div className="curriculum-item">
                <h3><FontAwesomeIcon icon={faBriefcase} className="me-2" /> Module 5: Capstone Project</h3>
                <p>Build a complete Tableau portfolio project</p>
                <div className="topics">
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> End-to-end analysis</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Executive dashboard</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Data storytelling</div>
                  <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Presentation skills</div>
                </div>
              </div>
            </section>
          </div>  
          
          <div className="course-sidebar">
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <div className="info-content">
                <h4>Duration</h4>
                <p>8 Weeks (15 hrs/week)</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faCertificate} />
              </div>
              <div className="info-content">
                <h4>Certifications</h4>
                <p>Tableau Desktop Specialist</p>
                <p>Tableau Certified Associate</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faLaptopCode} />
              </div>
              <div className="info-content">
                <h4>Projects</h4>
                <p>5 Portfolio-Ready Dashboards</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="info-content">
                <h4>Prerequisites</h4>
                <p>Basic Data Understanding</p>
                <p>No Prior Tableau Needed</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="info-icon">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>
              <div className="info-content">
                <h4>Career Support</h4>
                <p>Portfolio Review</p>
                <p>Interview Preparation</p>
              </div>
            </div>
            
            <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Tableau</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Tableau;